<template>
    <div class="menu_wrap">
        <div class="container">
            <div class="main_menu">
                <nav class="navbar navbar-expand-lg">
                    <button class="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
                    <a class="menu-bar" href="#">
                        <span class="bars bar1"></span>
                        <span class="bars bar2"></span>
                        <span class="bars bar3"></span>
                    </a>
                    </button>
                    <div class="collapse navbar-collapse" id="collapsibleNavbar">
                        <ul class=" navbar-nav" id="menu-header-menu">
                            
                            <li>
                                <a href="javascript:;"  :class="{active: isAboutActive,'about-us-menu':true}">About us</a>
                                <ul class="sub-menu">
                                    <li>
                                        <router-link class="nav-link" v-bind:to="'/about-us-arabic/'">About us (عربي  ) </router-link>
                                    </li>
                                    <li>
                                        <router-link class="nav-link" v-bind:to="'/about-us/'">About us ( English )</router-link>
                                    </li>
                                    <li>
                                        <router-link v-bind:to="'/vision/'">{{ $t("Vision") }}</router-link>
                                    </li>
                                    <li>
                                        <router-link v-bind:to="'/mission/'">{{ $t("Mission") }}</router-link>
                                    </li>
                                    <!-- <li>
                                        <router-link v-bind:to="'/core-values/'">{{ $t("Core Values") }}</router-link>
                                    </li>  -->
                                </ul>
                            </li>
                            <!-- <li>
                                <router-link v-bind:to="'/what-we-do/'">What we do</router-link>
                            </li>    -->
                            <li v-bind:class="{active:checkCurrentRoute('MedicalTrainingCenter')}">
                                <router-link  v-bind:to="'/medical-training-center/'">{{ $t("Nama Medical Training Center") }}</router-link>
                            </li>
                            <li v-bind:class="{active:checkCurrentRoute('NamaLearningManagement')}">
                                <router-link  v-bind:to="'/nama-learning-management/'">{{ $t("Nama Learning Management") }}</router-link>
                            </li>
                            <li v-bind:class="{active:checkCurrentRoute('DigitalHealthSolutions')}" >
                                <router-link v-bind:to="'/digital-health-solutions/'">{{ $t("Digital Healthcare Solutions") }}</router-link>
                            </li>
                            <li v-bind:class="{active:checkCurrentRoute('ConsultancyServices')}" >
                                <router-link v-bind:to="'/consultancy-services/'">{{ $t("Consultancy") }}</router-link>
                            </li>

                            <!-- <li>
                                <router-link v-bind:to="'/news-insights'">{{ $t("News & Insights") }}</router-link>
                            </li>
                            <li class="course">
                                <router-link v-bind:to="'/courses'">{{ $t("Courses") }}</router-link></li>
                             -->

                            <li v-bind:class="{active:checkCurrentRoute('ContactUs')}" >
                                <router-link v-bind:to="'/contact-us/'">{{ $t("Contact us") }}</router-link>
                            </li>
                        <!--<li>
                                <router-link v-bind:to="'/news/'">{{ $t("News") }}</router-link>
                            </li>
                            <li>
                                <router-link v-bind:to="'/faq/'">{{ $t("FAQ") }}</router-link>
                            </li>
                            <div class="logins">
                                <ul>
                                    <li v-if="!this.$store.state.auth.isLoggedIn" class="nav-item">
                                        <router-link class="nav-link" v-bind:to="'/login'">{{ $t("Header.Login") }}</router-link>
                                    </li>
                                    <li v-if="!this.$store.state.auth.isLoggedIn" class="nav-item">
                                        <router-link class="nav-link" v-bind:to="'/register'">{{ $t("Header.Register") }}</router-link>
                                    </li>
                                    <li v-if="this.$store.state.auth.isLoggedIn" class="nav-item">
                                        <router-link class="nav-link" v-bind:to="'/profile'">{{ $t("Header.Profile") }}</router-link>
                                    </li>
                                    <li v-if="this.$store.state.auth.isLoggedIn" class="nav-item">
                                        <a class="nav-link" @click.prevent="logout">{{ $t("Header.Logout") }}</a>
                                    </li>
                                </ul>
                            </div> -->
                        </ul>
                    </div>
                </nav>
                <!-- <div class="mobile_btns">
                    <div class="book_btn">
                        <a data-toggle="modal" data-target="#book_demo">{{ $t("Header.Book a demo") }}</a>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>


<script>

    export default {
        data() {
            return {
                auth: '',
                user: '',
                current_locale:this.$i18n_global.locale,
                isAboutActive:this.aboutActiveFun()
            }
        },
        methods:{
            checkCurrentRoute(route){
                return (this.$route.name == route);
            },
            aboutActiveFun(){
                if((this.$route.name == "StaticPage" ) || (this.$route.name == "Mission" ) || (this.$route.name == "Vision" ) ){
                    return true;
                }
                return false;
            }

        }
    }

</script>



// WEBPACK FOOTER //
// src/components/HeaderMenu.vue